module.exports = __webpack_public_path__ + "static/media/yellow.7b5ef4f3.png";